import styles from "./index.module.less";

type Props = {
  title: string;
};
function ModalSectionHeader({ title }: Props) {
  return (
    <div className={styles.sectionHeaderWithAction}>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <div className={styles.sectionIndicator} />
        <span className={styles.sectionTitle}>{title}</span>
      </div>
    </div>
  );
}
export default ModalSectionHeader;
